import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

interface ForkliftPosition {
  x: number;
  y: number;
  z: number;
  groundPositionAlias: string | null;
  groundPositionGroupLevelName: string | null;
}

interface User {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  type: string;
  currentDevice: null | string;
  tenantId: string;
  logConfig: string;
  createdAt: number;
  updatedAt: number;
  lastSeenAt: number;
  online: boolean;
}

interface GroundPositionGroup {
  id: string;
  tenantId: string;
  crateId: string;
  userId: string;
  type: string;
  tagRfid: string;
  x: number;
  y: number;
  z: number;
  timestamp: number;
  groundPositionAlias: string;
  groundPositionGroupLevelName: string;
  deviceName: string | null;
  taskType: string;
  previousSkuGroups: null | any; // Can be more specific if needed
  currentSkuGroups: null | any; // Can be more specific if needed
  forkliftPosition: ForkliftPosition;
  createdAt: number;
  updatedAt: number;
  user: User;
  levels: any[];
  positions: any[];
  name?: string;
} 

@Injectable({
  providedIn: 'root'
})
export class V3GroundPositionGroupsDataSourceService {
  baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop/ground-position-groups`;

  constructor(
    private http: HttpClient
  ) { }

  getAll() {
    return this.http.get<GroundPositionGroup[]>(`${this.baseUrl}`);
  }

  getById(id: string) {
    return this.http.get<GroundPositionGroup>(`${this.baseUrl}/${id}`);
  }
} 

